module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.fullLoading),
      expression: "fullLoading"
    }],
    staticClass: "transactions"
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.conditionLoading),
      expression: "conditionLoading"
    }],
    staticStyle: {
      "margin-top": "28px"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    staticStyle: {
      "padding-left": "28px",
      "padding-right": "10px"
    },
    attrs: {
      "span": 6
    }
  }, [_c('div', {
    staticClass: "col-md2-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('el-select', {
    attrs: {
      "filterable": ""
    },
    model: {
      value: (_vm.condition.outletId),
      callback: function($$v) {
        _vm.condition.outletId = $$v
      },
      expression: "condition.outletId"
    }
  }, _vm._l((_vm.shopOptions), function(item) {
    return _c('el-option', {
      attrs: {
        "label": item.name,
        "value": item.value
      }
    })
  }))], 1)])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('div', {
    staticClass: "col-md2-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('el-select', {
    attrs: {
      "filterable": ""
    },
    model: {
      value: (_vm.condition.status),
      callback: function($$v) {
        _vm.condition.status = $$v
      },
      expression: "condition.status"
    }
  }, _vm._l((_vm.statusOptions), function(item) {
    return _c('el-option', {
      attrs: {
        "label": item.name,
        "value": item.value
      }
    })
  }))], 1)])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('div', {
    staticClass: "col-md2-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('el-date-picker', {
    attrs: {
      "type": "datetimerange",
      "placeholder": _vm.$t('Date.placeholder')
    },
    model: {
      value: (_vm.datePicker),
      callback: function($$v) {
        _vm.datePicker = $$v
      },
      expression: "datePicker"
    }
  })], 1)])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('Views.Transactions.filter.id')
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.searchByCondition($event)
      }
    },
    model: {
      value: (_vm.condition.search),
      callback: function($$v) {
        _vm.condition.search = $$v
      },
      expression: "condition.search"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 sm-margin"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('sl-btn', {
    staticClass: "sl-btn-blue",
    attrs: {
      "text": _vm.$t('Functional.confirm')
    },
    nativeOn: {
      "click": function($event) {
        _vm.searchByCondition($event)
      }
    }
  }), _vm._v(" "), _c('sl-btn', {
    staticClass: "sl-btn-blue",
    attrs: {
      "text": _vm.$t('Functional.clear')
    },
    nativeOn: {
      "click": function($event) {
        _vm.clearSelectors($event)
      }
    }
  })], 1)])])], 1)], 1), _vm._v(" "), _c('row', [_c('div', {
    staticClass: "sl-col-4"
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "sl-body"
  }, [_c('row', {
    staticStyle: {
      "margin-bottom": "10px",
      "position": "relative",
      "left": "19px"
    }
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group",
    staticStyle: {
      "float": "right"
    }
  }, [_c('sl-btn', {
    attrs: {
      "text": _vm.$t('Functional.download'),
      "icon": "sl-download"
    },
    nativeOn: {
      "click": function($event) {
        _vm.download($event)
      }
    }
  })], 1)])]), _vm._v(" "), _c('row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.reloadBtn),
      expression: "reloadBtn"
    }],
    staticClass: "sl-table-reload"
  }, [_vm._v("\n          " + _vm._s(_vm.$t('Notify.errorMsg')) + "\n          "), _c('sl-btn', {
    staticClass: "sl-btn-lightblue",
    attrs: {
      "text": _vm.$t('Functional.reload')
    },
    nativeOn: {
      "click": function($event) {
        _vm.reloadTable($event)
      }
    }
  })], 1), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "border": ""
    },
    on: {
      "sort-change": _vm.handleSortChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "width": "200",
      "fixed": _vm.$store.state.userAgent.isPhone ? !true : true,
      "show-overflow-tooltip": true,
      "prop": "createTime",
      "label": _vm.$t('Views.Transactions.table.date')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm.formatterDate(scope.row)))]), _vm._v(" "), (scope.row.couponCode !== '') ? _c('img', {
          staticStyle: {
            "width": "20px",
            "height": "20px",
            "position": "relative",
            "top": "-1px"
          },
          attrs: {
            "src": "/static/imgs/coupon_icon.png"
          }
        }) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "200",
      "show-overflow-tooltip": true,
      "prop": "trxId",
      "label": _vm.$t('Views.Transactions.table.id')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "200",
      "show-overflow-tooltip": true,
      "prop": "amount",
      "label": _vm.$t('Views.Transactions.table.cAmount')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "200",
      "show-overflow-tooltip": true,
      "prop": "realAmount",
      "label": _vm.$t('Views.Transactions.table.realAmount')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "200",
      "show-overflow-tooltip": true,
      "prop": "settleAmount",
      "label": _vm.$t('Views.Transactions.table.amount')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "200",
      "show-overflow-tooltip": true,
      "prop": "status",
      "label": _vm.$t('Views.Transactions.table.status')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "200",
      "show-overflow-tooltip": true,
      "prop": "customer",
      "label": _vm.$t('Views.Transactions.table.customer')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('img', {
          staticStyle: {
            "width": "20px",
            "height": "20px"
          },
          attrs: {
            "src": ("/static/imgs/T-" + (scope.row.channelId) + ".png")
          }
        }), _vm._v(" "), _c('span', [_vm._v(_vm._s(scope.row.customer))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "200",
      "show-overflow-tooltip": true,
      "prop": "remark",
      "label": _vm.$t('Views.Transactions.table.remark')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "200",
      "show-overflow-tooltip": true,
      "prop": "outlet",
      "label": _vm.$t('Views.Transactions.table.outlet')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "200",
      "show-overflow-tooltip": true,
      "prop": "sn",
      "label": _vm.$t('Views.Transactions.table.posID')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "200",
      "show-overflow-tooltip": true,
      "prop": "username",
      "label": _vm.$t('Views.Transactions.table.posUsername')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": _vm.$store.state.userAgent.isPhone ? 100 : 200,
      "fixed": "right",
      "show-overflow-tooltip": true,
      "label": _vm.$t('Table.actions')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          staticClass: "sl-detail",
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.gotoPage(scope.row.id)
            }
          }
        }, [_vm._v(_vm._s(_vm.$tc('Table.view',
          1)))])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-pagination', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.reloadBtn),
      expression: "!reloadBtn"
    }],
    attrs: {
      "current-page": _vm.table.page,
      "page-sizes": [5, 10, 20, 50, 100],
      "page-size": _vm.table.per,
      "small": "",
      "layout": " prev, pager, next, sizes,jumper,total",
      "total": _vm.table.total
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-71739cdf!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/transactions/transactions.vue
// module id = 1118
// module chunks = 1